import { Avatar, Spin } from 'antd'
import React from 'react'
import Flex from '../../../components/Flex'
import CallIcon from '../../../components/icons/CallIcon'
import MailIcon from '../../../components/icons/MailIcon'

import { FolderSpinner } from '../../Placement/style'
import { ResumeDiv } from '../../Students/Partials/StudentsInfoTable/ViewStudentDrawer/Partials/StudentDrawerContent/Style/style'
import {
  CollegeName,
  DrawerHeader,
  HeaderFlexOne,
  InfoSection,
  StudentName,
} from '../../Students/Partials/StudentsInfoTable/ViewStudentDrawer/style'
import { MenuItem, OptedOutText, OptOutDiv, SectionNavMenu } from '../style'
import ResumePreview, { getUploadedCvUrl } from '../../../components/ResumePreview'
import StudentResumeDetailsAction from './StudentResumeDetailsAction'

const ViewResumeDrawer = ({
  viewDrawer,
  setViewDrawer,
  isLoading,
  setIsLoading,
  getPreviewData,
  previewData,
  roleID="",
  resumeMeta,
}) => {
  // Show the CV the candidate uploaded for this role; fall back to the
  // generated system resume only when they never uploaded one.
  const uploadedCvUrl = getUploadedCvUrl(resumeMeta)
  const candidateFullName =
    `${previewData?.firstName || ''} ${previewData?.lastName || ''}`.trim() ||
    'This candidate'
  const title = () => {
    return (
      <DrawerHeader flexWrap="wrap" gap="10px" centerVertically spaceBetween>
        <HeaderFlexOne centerVertically spaceBetween>
          <Flex wrap="wrap">
            <Avatar
              background
              src={previewData?.profileUrl}
              size={90}
              IconName={previewData?.firstName?.split('')?.[0]}
            />
            <InfoSection column center>
              <StudentName>
                {previewData?.firstName} {previewData?.lastName}
              </StudentName>
              <CollegeName>
                <MailIcon />
                {previewData?.admin?.email}
              </CollegeName>
              <CollegeName>
                <CallIcon />
                {previewData?.admin?.phone_number}
              </CollegeName>
            </InfoSection>
          </Flex>
        </HeaderFlexOne>
        <StudentResumeDetailsAction previewData={previewData} roleID={roleID} />
      </DrawerHeader>
    )
  }
  // The uploaded CV only — no generated-resume fallback, so a candidate who
  // never uploaded one reads as "No resume found" rather than showing a
  // document we built.
  const content = () => (
    <ResumePreview
      cvUrl={uploadedCvUrl}
      studentId={previewData?.id}
      roleId={roleID}
      candidateName={candidateFullName}
    />
  )
  return (
    <>
      {isLoading ? (
        <FolderSpinner>
          <Spin />
        </FolderSpinner>
      ) : (
        <ResumeDiv>
          {title()}
          {(previewData?.currentCourse?.optOutStatus === 1 ||
            previewData?.currentCourse?.optOutStatus === 4) && (
            <OptOutDiv>
              <OptedOutText strong>
                This student has opted out from the Placement Process.{' '}
              </OptedOutText>
            </OptOutDiv>
          )}
          <SectionNavMenu mode="horizontal" defaultSelectedKeys={['Resume']}>
            <MenuItem key="Resume">Resume</MenuItem>
          </SectionNavMenu>
          {content()}
        </ResumeDiv>
      )}
    </>
  )
}
export default ViewResumeDrawer
